module.exports = __webpack_public_path__ + "static/fabric-image-fit-center-44f236c83cb65ee9c03b3ff4e384538a.png";